// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bG-x0","label":"styles_label__2qVwy"};